import React from 'react'
import CartButton from './CartButton'
import {CartState} from '../../context/Context'



const CartTable = () => {
  const {state: {cart,favourite}, dispatch} = CartState();
  const increaseQty = (item) => {
   const value = item.qty + 1;
    dispatch({
      type: "CHANGE_CART_QTY",
      payload: {
        id: item.id,
        qty: value,
      },
    })
  }
  const decreaseQty = (item) => {
  const  value = item.qty - 1;
    dispatch({
      type: "CHANGE_CART_QTY",
      payload: {
        id: item.id,
        qty: value,
      },
    })
  }

  

  return (
    <table className="w-full auto">
    <thead >
    <tr className="flex lg:space-x-2 mb-6 border-b-2 border-slate-300">
<th className="w-2/12">Image</th>
<th scope="col" className="w-3/12">Product</th>
<th scope="col" className="w-2/12">Price</th>
<th scope="col" className="w-3/12">Quantity</th>
<th scope="col" className="w-2/12">Total</th>
</tr>
     </thead>
      <tbody className="space-y-4">
      {
        cart.map((item, index) => (
          <tr key={index} className="flex ">
            <td className="w-2/12 flex justify-center align-center">
              <img src={item.image} alt="product" className="w-6/12 h-18" />
            </td>
            <td className="w-3/12 flex justify-center align-center">
              <p className="font-bold text-base truncate">{item.name}</p>
            </td>
            <td className="w-2/12 flex justify-center">
              <p className="font-bold text-base">{item.price}</p>
            </td>
            <td className="w-3/12 flex justify-center ">
              {/* cart button */}
            <div className="flex border-2 space-x-2 justify-between px-2 h-8 ">
        <button className="outline-none border-none" onClick={ () => increaseQty(item)} >+</button>
        <p>{item.qty}</p>
        <button className="outline-none border-none" onClick={() => decreaseQty(item)} >-</button>
        {/* end of cart btn */}
    </div>
           
            </td>
            <td className="w-2/12 flex justify-center">
              <p className="font-bold text-base">{
                item.qty * item.price
              }</p>
            </td>
            </tr>
        ) )
      }
      </tbody>
  </table>
  )
}

export default CartTable